import { SmoothScroll } from "@/components/SmoothScroll";
import { GrainOverlay } from "@/components/GrainOverlay";
import { Navbar } from "@/components/Navbar";
import { HeroScrollSequence } from "@/components/HeroScrollSequence";
import { StatsBar } from "@/components/StatsBar";
import { HowItWorks } from "@/components/HowItWorks";
import { AIAgentsBento } from "@/components/AIAgentsBento";
import { DiagnosticMockUI } from "@/components/DiagnosticMockUI";
import { VinLookup } from "@/components/VinLookup";
import { Pricing } from "@/components/Pricing";
import { FAQ } from "@/components/FAQ";
import { Footer } from "@/components/Footer";
import { Toaster } from "sonner";

export default function Landing() {
  return (
    <div className="relative bg-void text-white" style={{ overflowX: "clip" }}>
      <SmoothScroll />
      <GrainOverlay />
      <Navbar />
      <main>
        <HeroScrollSequence />
        <StatsBar />
        <HowItWorks />
        <AIAgentsBento />
        <DiagnosticMockUI />
        <VinLookup />
        <Pricing />
        <FAQ />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}
